import $ from 'jquery';
import Chart, { Interaction, plugins } from 'chart.js/auto';

const benchmark = {
    variables : {
        benchmarkData : null,
        latestNav:null,
        mychart: null,
    },
    methods : {
        fetchData : (element) => {
            const isfund = $(element).data('fundcheckbox');
            const url = isfund ? '/bin/chli/json?path=latestnav' : '/bin/chli/json?path=benchmark';
            $.ajax({
                url: url,
                method: 'GET',
                success: (response) => {
                    benchmark.methods.storedData(element, JSON.parse(response), isfund);
                },
                error: (xhr, status, error) => {
                    if (isfund) {
                        console.error("Error fetching fund data:", error);
                    } else {
                        console.error("Error fetching latest nav data:", error);
                    }
                }
            }); 
        },
        storedData : (element, response, isfund)=>{
            if(isfund){
                benchmark.variables.latestNav = response;
            }else{
                benchmark.variables.benchmarkData = response;
            }
            benchmark.methods.initializeData(element);
            benchmark.methods.handleGraph(element);
            benchmark.methods.handleTabClick(element);
            benchmark.methods.handleFilterClick(element);
            benchmark.methods.handleFilterClickMobile(element);
            benchmark.methods.handleCalendar(element);
            benchmark.methods.filterClickDatalayer();
            benchmark.methods.radioButtonDatalayer();
        },
        initializeData : (element)=>{
            const tabName = $(element).find(".benchmark__tabs").find(".benchmark__tabs--item").eq(0).text();
            if($(window).width() >= 768){
                $(element).find('.benchmark__filter-items--item').eq(0).addClass('selected')
            }else{
                $(element).find('.benchmark__select-items--item').eq(0).addClass('selected');
            }
            if($(element).data('fundcheckbox') == true){
                benchmark.methods.filterTab(tabName,benchmark.variables.latestNav ,element, true);
            }else{
                benchmark.methods.filterTab(tabName, benchmark.variables.benchmarkData,element, false);
            }
        },
        filteredData : (lastMonth, isyear, data,isfund)=>{
            let arr = [];
            lastMonth = new Date(lastMonth);
            lastMonth.setDate(lastMonth.getDate() - 1);
            if(isfund){
                $.each(data,(idx, set)=>{
                    let funddate = set.funddate;
                    let funddateObject = new Date(funddate);
                    if(funddateObject >= lastMonth){
                        arr.push(set);
                    }
                })        
            }else{
                $.each(data.benhmarkHistoryRecords,(idx, set)=>{
                    let funddate = set.fundDate;
                    let funddateObject = new Date(funddate);
                    if(funddateObject >= lastMonth){
                        arr.push(set);
                    }
                })
            }
            return arr;
        },
        filterTab: (tabName, data,element)=>{
            const isfund = $(element).data('fundcheckbox');
            let date = new Date();
            let filteredData;
            let updatedData = data;
            if(isfund){
                updatedData = [];
                let fundcode = null;
                if($(window).width() >= 768){
                    fundcode = $(element).find('.benchmark__filter-items').find('.selected').find('.benchmark__filters-text').data('fundcode');
                }else{
                    fundcode = $(element).find('.benchmark__select-items').find('.selected').data('fundcode');
                }
                $.each(data.navhistoryRecords,(idx, dataset)=>{
                    Object.entries(dataset).map(entry => {
                        let key = entry[0];
                        if(key == fundcode){
                            updatedData.push({
                                funddate : dataset.FUND_DATE_FRM,
                                fundType : entry[1]
                            })
                        }
                    });
                })
            }
            switch(tabName) {
                case '1 month':
                  let lastMonth = date.setMonth(date.getMonth() - 1);
                  filteredData = benchmark.methods.filteredData(lastMonth,false,updatedData,isfund);
                  break;
                case '3 months':
                  let lastthreeMonth = date.setMonth(date.getMonth() - 3);
                  filteredData = benchmark.methods.filteredData(lastthreeMonth,false,updatedData,isfund);
                  break;
                case '6 months':
                  let lastSixMonth = date.setMonth(date.getMonth() - 6);
                  filteredData = benchmark.methods.filteredData(lastSixMonth,false,updatedData,isfund);
                  break;
                case '12 months':
                  let lastYear =  date.setFullYear(date.getFullYear() - 1);
                  filteredData = benchmark.methods.filteredData(lastYear,true,updatedData,isfund);
                  break;
                default:
            }
            if($(element).find('.benchmark__checkbox').find('.tableElement').hasClass('opted')){
                benchmark.methods.updateTable(filteredData, 'benchmark',element);
            }else{
                benchmark.methods.updateGraph(filteredData, 'benchmark',element);
            }
        },
        filterClickDatalayer : ()=>{
            $(".benchmark__filter-items--item").on('click', (e)=>{
                let text = e.currentTarget.getElementsByClassName("benchmark__filters-text")[0].innerText.replace(/\n/g, '').trim();
                let obj = benchmark.methods.dataLayerObj(text);
                createDataLayer("buttonClick", obj);
            })
        },

        radioButtonDatalayer : ()=>{
            $(".benchmark__checkbox--table-button").on('click', (e)=>{
                let text = e.currentTarget.parentElement.getElementsByClassName("benchmark__checkbox--table-label")[0].innerText.replace(/\n/g, '').trim();
                let obj = benchmark.methods.dataLayerObj(text);
                createDataLayer("buttonClick", obj);
            })
        },

        tabDatalayer: ()=>{
            $(".benchmark__tabs--item").on('click', ()=>{
                let obj = benchmark.methods.dataLayerObj(e);
                createDataLayer("buttonClick", obj);
            })
        },

        dataLayerObj: function (e) {
            var obj = {
              'articleName': "",
              'blogCategory': "",
              'blogPageCategory': "",
              'buttonText': e ? typeof (e) == 'string' ? e : e.currentTarget.innerText.replace(/\n/g, '').trim() : "",
              'pageSection': "Benchmark Yield Nav History",
              'planOption': "",
              'productCategory': "",
              'productName': "",
              'question': "",
              'searchTerm': "",
              'videoTitle': "",
              'bannerName': "",
              'bannerType': ""
            }
            return obj;
          },
        
        updateGraph : (datasets, dataname, element)=>{
            const isfund = $(element).data('fundcheckbox');
            $(element).find('.chart__container').show();
            $(element).find(".benchmark__table").find('table').find("tbody").empty();
            $(element).find(".benchmark__table").find('table').find("thead").empty();
            $(element).find(".benchmark__table").find('table').hide();
            const chartElement = $(element).find('.benchmark__graph-line')[0].getContext("2d");
            if(benchmark.variables.mychart){
                benchmark.variables.mychart.destroy();
            }
            if (datasets.length > 150) {
                datasets = datasets.slice(0, 150);
            }
            let xlabel = [];
            let ylabel = [];
            let ycode = '5 Year Benchmark Yield In Percentage';
            if(isfund){
                if($(window).width() >= 768){
                    ycode = $(element).find('.benchmark__filter-items').find('.selected').find('.benchmark__filters-text').text();
                }else{
                    ycode = $(element).find('.benchmark__select-items').find('.selected').text();
                }
                datasets.map((dataset)=>{
                    xlabel.push(dataset.funddate);
                    ylabel.push(dataset.fundType);
                })
            }else{
                datasets.map((dataset)=>{
                    xlabel.push(dataset.fundDate);
                    let benchmark = dataset.benchmark.replace("%","")
                    ylabel.push(benchmark);
                })
            }
            const isMobile = window.innerWidth <= 768;
            let scaleFont,tickFont ;
            if(isMobile){
                scaleFont = 10;
                tickFont = 8;
            }else{
                scaleFont = 16;
                tickFont = 12
            }
            const verticalHoverLine = {
                id: 'verticalHoverLine',
                afterDraw(chart) {
                    const { ctx, chartArea: { top, bottom } } = chart;
                    const activeElements = chart.tooltip._active;
                    if (activeElements && activeElements.length) {
                        const { x } = activeElements[0].element;
                        ctx.save();
                        ctx.beginPath();
                        ctx.strokeStyle = '#0067B1';
                        ctx.setLineDash([10, 5]);
                        ctx.lineWidth = 1;
                        ctx.moveTo(x, top);
                        ctx.lineTo(x, bottom);
                        ctx.stroke();
                        ctx.restore();
                    }
                }
            };
            let options = {
                maintainAspectRatio: false,
                scales: {
                    y: {
                        ticks: {
                            font: {
                                size: tickFont,
                                weight: 400,
                                family: 'Satoshi'
                            },
                            color: '#A8A8A8',
                            maxTicksLimit: 6
                        },
                        title: {
                            display: true,
                            text: ycode,
                            font: {
                                size: scaleFont,
                                weight: 700,
                                family: 'Satoshi'
                            },
                            color: '#A8A8A8'
                        },
                        stacked: true,
                        grid: {
                            z:1,
                            color: "#ECE9F1",
                        },
                        border: {
                            display: false
                        }
                    },
                    x: {
                        ticks: {
                            font: {
                                size: tickFont,
                                weight: 400,
                                family: 'Satoshi'
                            },
                            color: '#A8A8A8'
                        },
                        grid: {
                            display: false
                        },
                        border: {
                            display: false
                        }
                    }
                },
                interaction: {
                    mode: 'index',
                    intersect: false
                },
                plugins: {
                    verticalHoverLine
                },
                elements: {
                    line: {
                        fill: true
                    }
                }
            };
            Chart.register(verticalHoverLine);
            benchmark.variables.mychart = new Chart(chartElement, {
                type: 'line',
                data: {
                    labels: xlabel,
                    datasets: [{
                        label: ycode,
                        backgroundColor: "#F1FBFE",
                        borderColor: "#0C73B4",
                        borderWidth: 3,
                        fill: true,
                        hoverBackgroundColor: "#0C73B4",
                        hoverBorderColor: "#ffffff",
                        data: ylabel,
                        pointHitRadius: 0,
                        hitRadius: 0,
                        pointRadius: 0,
                        tension: (isMobile ? 0.4 : 0)
                    }]
                },
                options: options
            });
            const chartContainerBody = $(element).find('.chart__container--wrapper').get(0);
            let totallength = benchmark.variables.mychart.data.labels.length;
            if (totallength > 7) {
                const newwidth = 700 + ((totallength - 7) * 150);
                chartContainerBody.style.width = `${newwidth}px`;
            } else {
                chartContainerBody.style.width = '100%';
            }            
        },
        updateTable : (data, dataname,element)=>{
            $(element).find(".benchmark__table").find('table').show();
            $(element).find('.chart__container').hide();
            const isfund = $(element).data('fundcheckbox');
            if(benchmark.variables.mychart){
                benchmark.variables.mychart.destroy();
            }
            let fundcode = null;
            if($(window).width() >= 768){
                fundcode = $(element).find('.benchmark__filter-items').find('.selected').find('.benchmark__filters-text').text();
            }else{
                fundcode = $(element).find('.benchmark__select-items').find('.selected').text();
            }
            $(element).find(".benchmark__table").find('table').find("tbody").empty();
            $(element).find(".benchmark__table").find('table').find("thead").empty();
            const tableElement = $(element).find(".benchmark__table").find('table');
            if(isfund){
                const th = `<tr><th>Date</th><th>${fundcode}</th></tr>`;
                $(tableElement).find("thead").append(th);
                $.each(data,(idx, dataset)=>{
                    const tr = `<tr><td>${dataset.funddate}</td><td>${dataset.fundType}</td></tr>`;
                    $(tableElement).find("tbody").append(tr);
                })
            }else{
                const th = `<tr><th>Date</th><th>5 Year Benchmark Yield</th></tr>`;
                $(tableElement).find("thead").append(th);
                $.each(data,(idx, dataset)=>{
                    const tr = `<tr><td>${dataset.fundDate}</td><td>${dataset.benchmark}</td></tr>`;
                    $(tableElement).find("tbody").append(tr);
                })
            }
        },
        handleTabClick : (element)=>{
            $(element).find(".benchmark__tabs").find(".benchmark__tabs--item").each((i, item)=>{
                $(item).on('click',(e)=>{
                    $(element).find(".benchmark__tabs").find(".benchmark__tabs--item").removeClass('selected');
                    $(element).find(".benchmark__calendar").find('.to').val('');
                    $(element).find(".benchmark__calendar").find('.from').val('');
                    $(element).find(".benchmark__calendar").find('.benchmark__calendar--error').addClass('opacity-0');
                    $(item).addClass('selected');
                    if($(element).data('fundcheckbox') == true){
                        benchmark.methods.filterTab($(item).text(), benchmark.variables.latestNav,element)
                    }else{
                        benchmark.methods.filterTab($(item).text(), benchmark.variables.benchmarkData,element)
                    }
                })
            })
        },
        handleGraph : (element)=>{
            $(element).find('.benchmark__checkbox--table').each((idx, option)=>{
                $(option).on('click',(e)=>{
                    $(element).find('.benchmark__checkbox--table').removeClass('opted');
                    $(option).addClass('opted');
                    const tabText = $(element).find('.benchmark__tabs').find('.selected').text();
                    const toDate = $(element).find(".benchmark__calendar").find('.to').val();
                    const fromDate = $(element).find(".benchmark__calendar").find('.from').val();
                    if($(element).data('fundcheckbox') == true){
                        if(fromDate && toDate){
                            benchmark.methods.filterbyCalendar(fromDate,toDate,element);
                        }else{
                            benchmark.methods.filterTab(tabText, benchmark.variables.latestNav,element)
                        }
                    }else{
                        if(fromDate && toDate){
                            benchmark.methods.filterbyCalendar(fromDate,toDate,element);
                        }else{
                            benchmark.methods.filterTab(tabText, benchmark.variables.benchmarkData,element)
                        }
                    }
                })
            })
        },
        handleFilterClick : (element)=>{
            $(element).find('.benchmark__filter-items').find('.benchmark__filter-items--item').each((idx,item)=>{
                $(item).on('click',(e)=>{
                   const tabname = $(element).find(".benchmark__tabs").find('.selected').text();
                   $(element).find('.benchmark__filter-items').find('.benchmark__filter-items--item').removeClass('selected');
                   $(item).addClass('selected');
                   if(tabname){
                        benchmark.methods.filterTab(tabname, benchmark.variables.latestNav,element)
                   }
                   else{
                        const toDate = $(element).find(".benchmark__calendar").find('.to').val();
                        const fromDate = $(element).find(".benchmark__calendar").find('.from').val();
                        benchmark.methods.filterbyCalendar(fromDate,toDate,element);
                   }
                })
            })
        },
        handleFilterClickMobile : (element)=>{
            $(element).find('.benchmark__select-items').each((idx, select) => {
                $(select).on('change', (e) => {
                    const tabname = $(element).find(".benchmark__tabs").find('.selected').text();
                    $(element).find('.benchmark__select-items').find('.benchmark__select-items--item').removeClass('selected');
                    $(e.target).find(':selected').addClass('selected'); 
                    if(tabname){
                        benchmark.methods.filterTab(tabname, benchmark.variables.latestNav,element)
                    }
                    else{
                        const toDate = $(element).find(".benchmark__calendar").find('.to').val();
                        const fromDate = $(element).find(".benchmark__calendar").find('.from').val();
                        benchmark.methods.filterbyCalendar(fromDate,toDate,element);
                    }
                });
            });
        },
        filterbyCalendar : (fromDate, toDate,element)=>{
            const isfund = $(element).data('fundcheckbox');
            $(element).find(".benchmark__tabs").find(".benchmark__tabs--item").removeClass('selected');
            let updatedData = benchmark.variables.latestNav;
            if(isfund){
                updatedData = [];
                let fundcode = null;
                let fundlabel = null;
                if($(window).width() >= 768){
                    fundcode = $(element).find('.benchmark__filter-items').find('.selected').find('.benchmark__filters-text').data('fundcode');
                    fundlabel = $(element).find('.benchmark__filter-items').find('.selected').find('.benchmark__filters-text').text();
                }else{
                    fundcode = $(element).find('.benchmark__select-items').find('.selected').data('fundcode');
                    fundlabel = $(element).find('.benchmark__select-items').find('.selected').text();
                }
                $.each(benchmark.variables.latestNav.navhistoryRecords,(idx, dataset)=>{
                    Object.entries(dataset).map(entry => {
                        let key = entry[0];
                        if(key == fundcode){
                            updatedData.push({
                                funddate : dataset.FUND_DATE_FRM,
                                fundType : entry[1]
                            })
                        }
                    });
                })
                fromDate = new Date(fromDate);
                toDate = new Date(toDate);
                fromDate.setDate(fromDate.getDate() - 1);
                const filteredData = updatedData.filter(item => {
                    const itemDate = new Date(item.funddate);
                    return itemDate >= fromDate && itemDate <= toDate;
                });
                $(element).find(".benchmark__table").find('table').find("thead").empty();
                $(element).find(".benchmark__table").find('table').find("tbody").empty();
                if($(element).find('.benchmark__checkbox').find('.tableElement').hasClass('opted')){
                    const tableElement = $(element).find(".benchmark__table").find('table');
                    const th = `<tr><th>Date</th><th>${fundlabel}</th></tr>`;
                    $(tableElement).find("thead").append(th);
                    $.each(filteredData ,(idx, dataset)=>{
                        const tr = `<tr><td>${dataset.funddate}</td><td>${dataset.fundType}</td></tr>`;
                        $(tableElement).find("tbody").append(tr);
                    })
                }else{
                    benchmark.methods.updateGraph(filteredData, 'some', element);
                }
            }else{
                updatedData = benchmark.variables.benchmarkData.benhmarkHistoryRecords
                fromDate = new Date(fromDate);
                toDate = new Date(toDate);
                fromDate.setDate(fromDate.getDate() - 1);
                const filteredData = updatedData.filter(item => {
                    const itemDate = new Date(item.fundDate);
                    return itemDate >= fromDate && itemDate <= toDate;
                });
                $(element).find(".benchmark__table").find('table').find("thead").empty();
                $(element).find(".benchmark__table").find('table').find("tbody").empty();
                if($(element).find('.benchmark__checkbox').find('.tableElement').hasClass('opted')){
                    $(element).find(".benchmark__table").find('table').show();
                    $(element).find('.chart__container').hide();
                    const tableElement = $(element).find(".benchmark__table").find('table');
                    const th = `<tr><th>Date</th><th>5 Year benchmark yeild</th></tr>`;
                    $(tableElement).find("thead").append(th);
                    $.each(filteredData ,(idx, dataset)=>{
                        const tr =  `<tr><td>${dataset.fundDate}</td><td>${dataset.benchmark}</td></tr>`;
                        $(tableElement).find("tbody").append(tr);
                    })
                }else{
                    benchmark.methods.updateGraph(filteredData, 'some', element);
                }
            }
        },
        handleCalendar : (element)=>{
            $(element).find(".benchmark__calendar").find(".benchmark__calendar--date").each((idx, dateitem)=>{
                $(dateitem).on('change',(e)=>{
                    let fromDate =  $(element).find(".benchmark__calendar").find('.from').val();
                    let toDate = $(element).find(".benchmark__calendar").find('.to').val();
                    if(fromDate && toDate){
                        let fromdateobject = new Date(fromDate);
                        let todateobject = new Date(toDate);
                        if(fromdateobject <= todateobject){
                            $(element).find(".benchmark__calendar").find('.benchmark__calendar--error').addClass('opacity-0');
                            benchmark.methods.filterbyCalendar(fromDate,toDate,element);
                        }else{
                            $(element).find(".benchmark__calendar").find('.benchmark__calendar--error').removeClass('opacity-0');
                        }
                    } 
                })
            })
        },
        init : ()=>{
            $(".benchmark").each((idx, element)=>{
                benchmark.methods.fetchData(element);
            })
        }
    }
}

$(()=>{
    benchmark.methods.init();
})